// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../lastDayOfWeek/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var lastDayOfWeekWithOptions = convertToFP(fn, 2);
export default lastDayOfWeekWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/lastDayOfWeekWithOptions/index.js
// module id = 955
// module chunks = 0